// extracted by mini-css-extract-plugin
module.exports = {"promptTitleCapitalize":"_6713f97"};